const padNumber = (num, length) => {
  return String(num).padStart(length, '0');
};

export default padNumber;
